import React, { useCallback, useMemo, useRef, useState } from 'react';
import { NewMessagesAnchorContext } from './new-messages-anchor-context';

/*
  Mounted above the chat registry because the anchor is written by the boundary
  provider inside it but read by the chat-message registration the registry itself
  invokes — the value has to exist before either of them renders.
*/
export const NewMessagesAnchorProvider = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  const [anchor, setAnchor] = useState<string | null>(null);
  const anchorRef = useRef<string | null>(null);

  const updateAnchor = useCallback((value: string | null) => {
    anchorRef.current = value;
    setAnchor(value);
  }, []);

  const value = useMemo(
    () => ({ anchor, anchorRef, setAnchor: updateAnchor }),
    [anchor, updateAnchor],
  );

  return (
    <NewMessagesAnchorContext.Provider value={value}>
      {children}
    </NewMessagesAnchorContext.Provider>
  );
};
